exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".maru[data-v-effdbb28]{height:42px;width:42px;border-radius:50%;line-height:42px;text-align:center;font-size:20px}.wrapper[data-v-effdbb28]{display:flex;justify-content:center;align-items:center;position:absolute;height:100%;width:100%}.wrap-name[data-v-effdbb28],.wrap-place[data-v-effdbb28]{display:flex;white-space:nowrap}.wrap-name .intv-name[data-v-effdbb28],.wrap-name .intv-place[data-v-effdbb28],.wrap-place .intv-name[data-v-effdbb28],.wrap-place .intv-place[data-v-effdbb28]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
